// export interface AccountModel {
//   id: number;
//   login: string;
// }

import { PAYMENT_MNT } from '@/constants';
import { convertDateToCustomFormat } from '@/util/date-util';

export class Account {
  id: number;
  login: string;

  constructor(id: number, login: string) {
    this.id = id;
    this.login = login;
  }
}

export class UserPlan {
  paidplanId: number;
  isNextPlan: boolean;
  plan: string;
  nextPaid: string;
  period: string;
  productType: number;
  productId: number;
  endDate: string;
  startDate: string;
  totalAmount: number;
  planView: string;
  lastName: string;
  stripeAmountPaid: number;
  canceledDate: string;
  stripeSubscriptionId: string;
  stripeBalance: number;
  currency: string;

  constructor() {
    this.productType = -1;
    this.nextPaid = '';
    this.startDate = '';
    this.endDate = '';
    this.period = '';
    this.productId = 0;
    this.totalAmount = 0;
    this.planView = 'Free Trial';
    this.lastName = '';
    this.stripeBalance = 0;
    this.currency = 'USD';
  }

  getPeriod(startDate: string, endDate: string): string {
    if (startDate && endDate) {
      const start = convertDateToCustomFormat(new Date(startDate), 'yyyy.MM.dd');
      const end = convertDateToCustomFormat(new Date(endDate), 'yyyy.MM.dd');
      return start + ' ~ ' + end;
    }
    return '';
  }
}
